import 'whatwg-fetch'

const _options = {}

/**
 * 注册配置信息
 * @param options 配置信息
 */
export function config (options) {
  Object.assign(_options, options)
  if (options.token) {
    setAccessToken(options.token)
  }
}

export function get (url, headers, option) {
  if (!option || option.ignoreAOP !== true) {
    before()
  }

  headers = {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers,
      token: getAccessToken(),
      'Authorization': getAccessToken() ? 'Bearer ' + getAccessToken() : ''
    }
  }

  return new Promise((resolve, reject) => {
    fetch(url, headers)
      .then(response => {
        let json = {}
        let contentType = response.headers.get('Content-Type').split(';')[0]
        if (contentType === 'application/json') {
          json = response.json()
        } else if (contentType === 'application/octet-stream') {
          response.blob().then(blob => {
            let a = document.createElement('a')
            let url = window.URL.createObjectURL(blob)   // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
            let name = response.headers.get('Content-Disposition')
            name = name.split('name=')[1].split(';')[0]
            a.href = url
            a.download = name
            a.click()
            window.URL.revokeObjectURL(url)
          })
        }
        return json
      })
      .then(responseJson => {
        responseJson = after(responseJson, url, undefined, headers)
        resolve(responseJson)
      })
      .catch(error => reject(error))
  })
}

export function post (url, data, headers, option) {
  if (!option || option.ignoreAOP !== true) {
    before(url, data, headers)
  }

  headers = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers,
      token: getAccessToken(),
      'Authorization': getAccessToken() ? 'Bearer ' + getAccessToken() : ''
    },
    body: JSON.stringify(data)
  }

  return new Promise((resolve, reject) => {
    fetch(url, headers)
      .then(response => {
        let json = {}
        let contentType = response.headers.get('Content-Type').split(';')[0]
        let contentDisposition = response.headers.get('Content-Disposition')
        if (contentType === 'application/json') {
          json = response.json()
        } else if (contentDisposition != null) {
          response.blob().then(blob => {
            let a = document.createElement('a')
            let url = window.URL.createObjectURL(blob)   // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
            let name = response.headers.get('Content-Disposition')
            name = name.split('name=')[1].split(';')[0]
            a.href = url
            a.download = name
            a.click()
            window.URL.revokeObjectURL(url)
          })
        }
        return json
      })
      .then(responseJson => {
        responseJson = after(responseJson, url, data, headers)
        resolve(responseJson)
      })
      .catch(error => reject(error))
  })

}

export function bapPost (url, data, headers, option) {
  if (!option || option.ignoreAOP !== true) {
    before(url, data, headers)
  }

  headers = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers,
      token: getAccessToken(),
      'Authorization': getAccessToken() ? 'Bearer ' + getAccessToken() : ''
    },
    body: JSON.stringify(data)
  }

  return new Promise((resolve, reject) => {
    fetch(url, headers)
      .then(response => {
        let json = {}
        let contentType = response.headers.get('Content-Type').split(';')[0]
        let contentDisposition = response.headers.get('Content-Disposition')
        if (contentType === 'application/json') {
          json = response.json()
        } else if (contentDisposition != null) {
          response.blob().then(blob => {
            let a = document.createElement('a')
            let url = window.URL.createObjectURL(blob)   // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
            let name = response.headers.get('Content-Disposition')
            name = name.split('name=')[1].split(';')[0]
            a.href = url
            a.download = name
            a.click()
            window.URL.revokeObjectURL(url)
          })
        }
        return json
      })
      .then(responseJson => {
        responseJson = after(responseJson, url, data, headers)
        resolve(responseJson)
      })
      .catch(error => reject(error))
  })

}

function before (url, data, headers) {
  if (_options.before) {
    _options.before(url, data, headers)
  }
}

function after (response, url, data, headers) {
  if (_options.after) {
    return _options.after(response, url, data, headers)
  }

  return response
}

function getAccessToken () {
  return sessionStorage['_accessToken'] || ''
}

function setAccessToken (token) {
  sessionStorage['_accessToken'] = token
}

function clearAccessToken () {
  sessionStorage['_accessToken'] = ''
}

export default {
  config,
  fetch,
  get,
  post,
  getAccessToken,
  setAccessToken,
  clearAccessToken
}



// WEBPACK FOOTER //
// ./src/wbap-utils/fetch/index.js